const aux = (props) => props.children

export default aux


// WEBPACK FOOTER //
// ./src/hoc/Aux/Aux.js